/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { FindingSuggestionsFilters } from './findingSuggestionsQueryParams';
import { Brand, toBrand } from '../../../../shared/model/brand.model';
import { useAppDispatch } from '../../../../core/store';
import { SelectItem } from '../../../../shared/ModalSelectField';
import { ModalMultiSelectField } from '../../../../shared/ModalMultiSelectField';
import { selectPrincipal } from '../../../auth/store/principalSlice';
import { changeBrands, selectBrands } from '../../store/findingSuggestionsSlice';

interface BrandMultiSelectFieldProps {
  filters: FindingSuggestionsFilters;
  defaultValue?: Brand[];
  editable?: boolean;
  onUpdate?: (brand: Brand[]) => void;
}

export function BrandMultiSelectField({
  filters,
  defaultValue = [],
  editable = false,
  onUpdate,
}: BrandMultiSelectFieldProps) {
  const dispatch = useAppDispatch();
  const principal = useSelector(selectPrincipal);

  useEffect(() => {
    if (editable) {
      dispatch(changeBrands(principal.brands.map(bc => toBrand(bc))));
    }
  }, [dispatch, editable, filters, principal.brands]);

  const brandList = useSelector(selectBrands);

  const toSelectItem = (item: Brand): SelectItem => {
    return {
      code: item.code,
      description: item.description,
      logo: item.logo,
    };
  };

  const selectItemToBrand = (item: SelectItem): Brand => {
    return {
      code: item.code,
      description: item.description,
      logo: item.logo || '',
    };
  };

  return (
    <ModalMultiSelectField
      icon='copyright'
      defaultValue={defaultValue != null ? defaultValue.map(v => toSelectItem(v)) : []}
      list={brandList.map((b): SelectItem => toSelectItem(b) as SelectItem)}
      title={t('assessment.report.filters.brands') || ''}
      editable={editable && brandList?.length > 1}
      onUpdateValue={(selectedBrand: SelectItem[]) => {
        if (onUpdate) {
          onUpdate(selectedBrand.map(i => selectItemToBrand(i)));
        }
      }}
    />
  );
}
